/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_S2_CapInputs */

const en_funnel_ob_welcome_s2_cap = /** @type {(inputs: Funnel_Ob_Welcome_S2_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We turn it into natural audio.`)
};

const es_funnel_ob_welcome_s2_cap = /** @type {(inputs: Funnel_Ob_Welcome_S2_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo convertimos en audio natural.`)
};

/**
* | output |
* | --- |
* | "We turn it into natural audio." |
*
* @param {Funnel_Ob_Welcome_S2_CapInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_s2_cap = /** @type {((inputs?: Funnel_Ob_Welcome_S2_CapInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_S2_CapInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_s2_cap(inputs)
	return en_funnel_ob_welcome_s2_cap(inputs)
});